import {
	Component,
	output,
	QueryList,
	signal,
	ViewChildren,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MENU_NAVIGATION_DATA } from '../../../../core/navigation/menu-bar.data';
import { ultraAnimations } from '../../../animations';
import { RouterActiveDirective } from '../../../directives/router-active.directive';
import { UltraMenuItemExpandableComponent } from '../ultra-menu-item-expandable/ultra-menu-item-expandable.component';
import { AnchoredPortalDirective } from '../../../directives/anchored-portal.directive';
import { UltraMenuCardComponent } from '../ultra-menu-card/ultra-menu-card.component';

@Component({
	selector: 'app-ultra-navigation',
	templateUrl: 'ultra-navigation.component.html',
	imports: [
		UltraMenuCardComponent,
		UltraMenuItemExpandableComponent,
		RouterActiveDirective,
		MatIconModule,
		RouterLink,
	],
	styleUrls: ['ultra-navigation.component.scss'],
	animations: ultraAnimations,

	hostDirectives: [AnchoredPortalDirective],
})
export class UltraNavigationComponent {
	navigationData = MENU_NAVIGATION_DATA;
	@ViewChildren('expandableRef')
	expandableItems!: QueryList<UltraMenuItemExpandableComponent>;
	menuClose = output();

	activeRoute = signal<string>(null);

	onExpandedId(id: string) {
		setTimeout(() => {
			this.expandableItems.forEach((el) => {
				if (el.item().id !== id) {
					el.expanded.set(false);
				}
			});
		});
	}

	onActiveRoute(activeRoute: string) {
		this.activeRoute.set(activeRoute);
	}
}
